import { TOGGLE_PARKING_SPECIFIC_DETAIL_PANEL } from "./displayParkingSpecificDetailPanelReducer"

export const toggleParkingSpecificDetailPanel = (value) => ({
    type: TOGGLE_PARKING_SPECIFIC_DETAIL_PANEL,
    payload: value
})